module.exports = __webpack_public_path__ + "img/logo-noir.84bf3a10.svg";